<div class="modal-content modal-content-right">
  <div class="modal-header">
    <h5 class="modal-title"><i class="far fa-user-circle"></i>Pay Via Card</h5>
    <button type="button" class="close" (click)="close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-6">
        <p class="label-bold">Amount to be charged:</p>
        <div class="input-group pdb-20">
          <div class="input-group-prepend">
            <span class="input-group-text">$</span>
          </div>
          <input
            type="number"
            class="form-control"
            id="amountcharge"
            aria-describedby="amountcharge"
            disabled
            [(ngModel)]="amountToBePaid"
            class="form-control"
            name="amtpaid"
            placeholder="0.00"
          />
        </div>

        <p class="label-bold">Payment Details</p>
        <div class="form-group">
          <label for="addressId">Select Billing Address</label>
          <select
            [(ngModel)]="addressId"
            class="form-control"
            (change)="addressSelected()"
          >
            <option
              *ngFor="let addr of customerAddressList"
              value="{{ addr.Id }}"
            >
              {{ addr.StreetAddress }} {{ addr.City }} {{ addr.CountryCode }}
              {{ addr.ZipCode }}
            </option>
          </select>
          <a href="#" data-toggle="modal" (click)="addAddress()">
            <i class="fas fa-plus-circle"></i
            ><span
              >&nbsp;{{ customerId ? "Add address" : "Enter Address" }}</span
            >
          </a>
        </div>
        <!--start transit here-->
        <div *ngIf="processor === 'tsys'" class="form-group">
          <div *ngIf="level == '2' || level == '3'">
            <label for="addressShippingId">Select Shipping Address</label>
            <select
              [(ngModel)]="addressShippingId"
              class="form-control"
              (change)="addressShippingSelected()"
            >
              <option
                *ngFor="let addr1 of customerAddressList"
                value="{{ addr1.Id }}"
              >
                {{ addr1.StreetAddress }} {{ addr1.City }}
                {{ addr1.CountryCode }} {{ addr1.ZipCode }}
              </option>
            </select>
            <a href="#" data-toggle="modal" (click)="addAddress()">
              <i class="fas fa-plus-circle"></i
              ><span
                >&nbsp;{{ customerId ? "Add address" : "Enter Address" }}</span
              >
            </a>
          </div>
        </div>
        <!--end transit here-->

        <!--<div *ngIf="processor === 'transit'" class="form-group row">
          <label for="level">Level</label>
          <select [(ngModel)]="level" class="form-control" [ngModelOptions]="{standalone: true}">
            <option value="1" selected="true">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
          </select>
        </div>-->
        <br />
        <label *ngIf="customerId" class="label-chk bold">
          <input type="checkbox" [(ngModel)]="saveCard" /> Add card to my
          account
        </label>
        <label class="label-chk">
          <input type="checkbox" [(ngModel)]="agreedToTerms" /> I have read and
          agree to the
          <a
            class="redify"
            href="javascript:void(0)"
            (click)="openTermsAndCondition()"
            >Terms and Conditions</a
          >. Information will be used as described here and in the
          <a class="redify" href="javascript:void(0)" (click)="openPolicy()"
            >Privacy Policy</a
          >.
        </label>
      </div>
      <div class="col-md-6 heartland-iframe">
        <div *ngIf="processor === 'heartland'">
          <app-heartland-card-tokenizer
            #tokenizerForm
            [publicAPIKey]="publicAPIKey"
            submitText="Process Payment"
            (tokenData)="onCardTokenReceived($event)"
          >
          </app-heartland-card-tokenizer>
        </div>

        <div *ngIf="processor === 'tsys'">
          <!--          <app-transit-card-tokenizer (tokenData)="onCardTokenReceived($event)"></app-transit-card-tokenizer>-->
        </div>

        <div class="form-group row">
          <label class="col-md-3 col-form-label">&nbsp;</label>
          <div class="col-md-9">
            <span *ngIf="busy" class="text-danger bold"
              ><i class="fas fa-spinner fa-spin"></i>&nbsp;Processing. Please
              wait..</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="form-group">
      <span [hidden]="!!tokenizerForm && !tokenizerForm.tokenizerBusy"
        ><i class="fas fa-spinner fa-spin"></i
      ></span>
      <div
        [hidden]="!!tokenizerForm && tokenizerForm.tokenizerBusy"
        id="credit-card-submit"
      ></div>
    </div>
  </div>
</div>
<ng-template #container>
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{ tcpTitle }}</h4>
    <button
      type="button"
      class="close pull-right"
      aria-label="Close"
      (click)="closeCurrentDialog()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div [innerHTML]="tcpContent" class="tcp-content text-secondary"></div>
  </div>
</ng-template>
